module.exports = __webpack_public_path__ + "assets/mail-blue.fea18dc3.svg";